// Kartan aloitusnäkymä: kun sovellus avataan, kartta keskitetään pelaajaan.
//
// Ilman tätä kartta aukeaa Lappeenrantaan (oletusnäkymä) ja pelaaja joutuu etsimään itsensä,
// koska sijainti tunnetaan vasta, kun retki on käynnissä. Tässä on vain puhdas päätöslogiikka,
// jotta säännöt voi testata ilman karttaa; käyttö on MapScreen.jsx:ssä ja main.jsx:ssä.

/** Pienin zoom keskityksessä: näkyy lähialue ja ruudut (sama raja kuin "Keskitä omaan sijaintiin" -painikkeella). */
export const MIN_START_ZOOM = 15;

/** Taustalta palatessa kartta keskitetään uudelleen, jos sovellus oli piilossa vähintään näin kauan. */
export const RESUME_RECENTER_MS = 5 * 60 * 1000;

/**
 * Näkymä, johon kartta siirretään: pelaajan kohta ja zoom, joka on vähintään MIN_START_ZOOM.
 * Käyttäjän oma tarkempi zoom säilyy. Palauttaa null, jos sijainti ei kelpaa.
 */
export function startView(me, currentZoom) {
  if (!me || !Number.isFinite(me.latitude) || !Number.isFinite(me.longitude)) return null;
  const zoom = Number.isFinite(currentZoom) ? Math.max(currentZoom, MIN_START_ZOOM) : MIN_START_ZOOM;
  return { center: [me.latitude, me.longitude], zoom };
}

/**
 * Pitääkö kartta keskittää uudelleen, kun sovellus tulee takaisin esiin?
 * `hiddenSince`: milloin sovellus meni piiloon (null = ei tiedossa). Lyhyt poistuminen (esim. viesti
 * toisesta sovelluksesta) ei saa heittää karttaa pois siitä, mitä käyttäjä tarkastelee.
 */
export function needsRecenter(hiddenSince, now) {
  return hiddenSince != null && now - hiddenSince >= RESUME_RECENTER_MS;
}
